var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6447 0.706421C2.24468 0.706421 6.29468 11.6564 6.29468 11.6564C7.19468 13.1564 8.39468 12.8564 8.39468 13.9064C8.39468 14.8064 7.34468 15.1064 6.29468 15.2564C4.64468 15.2564 3.14468 14.9564 1.64468 17.6564C0.744678 19.3064 0.294678 24.7064 0.294678 24.7064H20.8447C20.8447 24.7064 20.3947 19.3064 19.6447 17.6564C18.1447 14.8064 16.6447 15.2564 14.9947 15.1064C13.9447 14.9564 12.8947 14.6564 12.8947 13.7564C12.8947 12.8564 14.0947 13.1564 14.9947 11.5064C14.9947 11.6564 19.0447 0.706421 10.6447 0.706421Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d4c14568b92cee6dced45a4f84e402d4.svg";
export { ForwardRef as ReactComponent };